import Vue from 'vue/dist/vue.js';
import retailerListItem from './vueComponents/retailerListItem.js';

Vue.config.productionTip = false;

export default {
    name: 'retailers',
    _instances: null,
    _retailers: null,
    init() {
        this._instances = document.querySelectorAll('[data-retailersearch]');
        if (!this._instances || this._instances.length===0) {
            return;
        }

        this.fetch();

    },

    fetch() {
        const request = new XMLHttpRequest();
        request.addEventListener('load', () => {
            if (request.readyState === 4 && request.status === 200) {
                this._retailers = JSON.parse(request.responseText);
                this._instances.forEach((el) => this.run(el));
            }
        });

        request.open('GET', '/actions/tellus/tellus/get-all-retailers');
        request.send();
    },

    run (el)
    {
        const siteId = JSON.parse(el.getAttribute('data-siteid'));

        const data = {
            isSearchToggled : false,
            retailerSearch : '',
            items : this._retailers,
            siteId : siteId,
            publicItems : [],
            lat : null,
            lng : null,
            links: this._links
        };

        new Vue({
            el: el,
            delimiters: ['@{', '}'],
            data: data,

            created()
            {
                this.updatePublicItems();
            },

            computed:
            {
                toggleSearchClass()
                {
                    return (this.isSearchToggled) ? 'find-department--active' : '';
                },
            },

            filters:
            {
                km(value)
                {
                    return parseInt(value);
                }
            },

            methods:
            {
                handlePhone(event) {
                    if (event.target.innerText === 'Vis telefonnr.') {
                        event.preventDefault();
                    }
                    event.target.innerText = event.target.href.replace('tel:', '');
                },

                toggleSearch()
                {

                    const el = document.getElementById('js_findDepartment');
                    const overlay = document.querySelector('.find-department__overlay');
                    const body = document.querySelector('body');
                    const header = document.querySelector('header');

                    if (el) {
                        this.isSearchToggled = !this.isSearchToggled;

                        if (this.isSearchToggled){
                            overlay.classList.add('find-department__overlay--active');
                            body.classList.add('no-scroll');
                            header.classList.remove("header--filter");

                        } else{
                            overlay.classList.remove('find-department__overlay--active');
                            body.classList.remove('no-scroll');
                            header.classList.add("header--filter");
                        }
                    }              
                },

                findRetailer()
                {
                    this.updatePublicItems();
                    // if (this.retailerSearch.length >= 3) {
                    //     this.updatePublicItems();
                    // } else {
                    //     this.publicItems = [];
                    // }
                },

                updatePublicItems()
                {
                    const filteredItems = this.items.filter(this.passedFilters);

                    if (this.lat && this.lng) {
                        filteredItems.map((retailer) => {
                            if (typeof retailer.position === 'object' && retailer.position !== null) {
                                retailer.distance = this.calcDistance(this.lat, this.lng, retailer.position.lat, retailer.position.lng, "K");
                            } else {
                                retailer.distance = 0;
                            }

                            return retailer;
                        });

                        filteredItems.sort((a, b) => (a.distance > b.distance) ? 1 : -1)
                    }

                    this.publicItems = filteredItems;
                },

                passedFilters(item)
                {
                    let isValid = true;

                    if (this.retailerSearch) {
                        isValid = false;

                        // find retailer name
                        if (item.name.toLowerCase().search(this.retailerSearch) !== -1) {
                            isValid = true;
                        }

                        // find retailer city
                        if (item.city.toLowerCase().search(this.retailerSearch) !== -1) {
                            isValid = true;
                        }

                        // find retailer zipcode
                        if (item.zipcode.toLowerCase().search(this.retailerSearch) !== -1) {
                            isValid = true;
                        }
                    }

                    return isValid;
                },

                showAll()
                {
                    this.publicItems = this.items;
                },

                resetRetailerSearch()
                {
                    this.retailerSearch = '';
                    this.updatePublicItems();
                },

                getUsersGeoPosition()
                {
                    // this.lat = 62.8413603;
                    // this.lng = 7.2272497;

                    if (!navigator.geolocation) {
                      console.warn('Geolocation is not supported');
                    } else {
                        // console.log('locating ...');
                        const options = {enableHighAccuracy: true, maximumAge: 10000};
                        navigator.geolocation.getCurrentPosition(
                            this.getUsersGeoPosition__success,
                            this.getUsersGeoPosition__error, options
                        );
                    }
                },

                getUsersGeoPosition__success(position)
                {
                    // console.log('getUsersGeoPosition__success');
                    // console.log(position);
                    // console.log(position.coords.latitude);
                    // console.log(position.coords.longitude);
                    this.lat = parseFloat(position.coords.latitude.toFixed(2));
                    this.lng = parseFloat( position.coords.longitude.toFixed(2));

                    setTimeout(this.updatePublicItems, 500);
                },

                getUsersGeoPosition__error()
                {
                   console.warn('geo position not allowed');
                   this.updatePublicItems();
                },

                calcDistance (lat1, lon1, lat2, lon2, unit)
                {
                    if ((lat1 == lat2) && (lon1 == lon2)) {
                        return 0;
                    }
                    else {
                        var radlat1 = Math.PI * lat1/180;
                        var radlat2 = Math.PI * lat2/180;
                        var theta = lon1-lon2;
                        var radtheta = Math.PI * theta/180;
                        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                        if (dist > 1) {
                            dist = 1;
                        }
                        dist = Math.acos(dist);
                        dist = dist * 180/Math.PI;
                        dist = dist * 60 * 1.1515;
                        if (unit=="K") { dist = dist * 1.609344 }
                        if (unit=="N") { dist = dist * 0.8684 }
                        return dist;
                    }
                },
            }
        });

    }
}